import React, { Component } from 'react'
import { Grid, withStyles, Paper, Hidden } from '@material-ui/core'
import { trackPage, isBaseDomain } from 'utils'
import logoImg from 'images/svg/logo-2.svg'

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  root: {
    display: 'block',
    padding: '0px',
    width: '100%',
    margin: '0 0 -200px',
  },
  logoSpan: {
    display: 'flex',
    paddingLeft: '14px',
    '& > img': {
      width: '187px',
      [theme.breakpoints.down('961')]: { height: '28px', width: 'auto' },
      [theme.breakpoints.down('600')]: { height: 'auto' },
    },
  },
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '64px',
  },
  mobileLogo: {
    height: '25px',
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing.unit,
  },
  termsCards: {
    background: 'transparent',
    boxShadow: 'none',
  },
  termsPagetitle: {
    fontSize: '24px',
    fontWeight: '500',
    letterSpacing: '-0.36px',
    color: '#000',
    padding: '0 0 24px',
    margin: '0',
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  termsSubtitle: {
    color: '#000',
    fontSize: '16px',
    fontWeight: '500',
    padding: '10px 0 15px',
  },
  termsboldPara: {
    fontSize: '14px',
    color: '#000000',
    paddingBottom: '20px',
    lineHeight: '1.6',
    margin: '0',
  },
  termsPara: {
    color: '#000',
    margin: '0',
    fontSize: '14px',
    lineHeight: '1.6',
    padding: '0 0 20px',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    '& span': {
      display: 'block',
      width: '40px',
      flex: 'none',
    },
    '& p': {
      margin: '0',
      flex: '1',
    },
  },
  termsParaLeft: {
    color: '#000',
    margin: '0',
    lineHeight: '1.6',
    fontSize: '14px',
    padding: '0 0 20px 40px',
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  gridList: {
    margin: '0px auto',
    width: 'auto',
    maxWidth: '1240px',
    textAlign: 'justify',
    [theme.breakpoints.down('1241')]: {
      maxWidth: '97%',
    },
  },
  gridFlex: {
    display: 'flex',
  },
  termItem: {
    width: '100%',
    padding: '12px',
  },
})

class Terms extends Component {
  componentDidMount() {
    trackPage(window.location.pathname)
  }

  getHVALogo(classes) {
    const logo = (
      <React.Fragment>
        <Hidden xsDown>
          <img src={logoImg} height="42px" alt={'logo'} />
        </Hidden>
        <Hidden smUp>
          <div className={classes.mobileLogo}>
            <img src={logoImg} height="25px" alt={'logo'} />
          </div>
        </Hidden>
      </React.Fragment>
    )

    return (
      <Grid item className={classes.logoWrapper}>
        {/* The home link will be build using a html link if we are under a subdomain, since we want to redirect to home main/base domain, if not we build it using react-router link to no reload the app } */}
        {!isBaseDomain(window.location.hostname) ? (
          //FIXME we can extract this logic to create url somewhere
          <a
            href={`${window.location.protocol}//${process.env.REACT_APP_BASE_DOMAINS}${window.location.port ? ':' + window.location.port : ''}`}
            className={classes.logoSpan}
            id={'hva_logo'}>
            {logo}
          </a>
        ) : (
          <span className={classes.logoSpan} id={'hva_logo'}>
            {logo}
          </span>
        )}
      </Grid>
    )
  }

  render() {
    const { classes } = this.props

    return (
      <Grid container className={classes.flex}>
        {this.getHVALogo(classes)}

        <div className={classes.root}>
          <Grid container spacing={24} className={classes.gridList}>
            <Grid className={classes.termItem}>
              <Paper className={classes.termsCards}>
                <h3 className={classes.termsPagetitle}>TERMS OF USE</h3>
                <div className={classes.termsboldPara}>
                  BY USING ANY WEBSITE OR SERVICE OF HOMEVESTORS OF AMERICA, INC. (“HOMEVESTORS”) YOU AGREE TO ABIDE BY THESE TERMS OF USE BETWEEN YOU AND
                  HOMEVESTORS, WHICH INCLUDE THE REFERENCED PRIVACY POLICY (“AGREEMENT”). IF YOU DO NOT AGREE TO BE BOUND BY THIS AGREEMENT, YOU ARE NOT
                  AUTHORIZED TO USE ANY HOMEVESTORS WEBSITE OR TO OBTAIN ANY SERVICES FROM HOMEVESTORS.
                </div>
                <div className={classes.termsPara}>
                  The HomeVestors website includes DealVestors.com (“Website”). HomeVestors provides numerous services, including as referenced on the Website
                  (“Services”). The Website includes homes being offered for sale by our franchisees. Each of our franchisees are independently owned and
                  operated. Any transaction that you enter into with a franchisee concerning any property, including one listed on the Website, is a transaction
                  solely between you and the franchisee and subject to any contract entered. You agree and acknowledge that HomeVestors makes no representations
                  or warranties to you with respect to any such property, transaction or contract.{' '}
                </div>
                <div className={classes.termsPara}>
                  HomeVestors reserves the right, at its discretion, to revise the terms of this Agreement and/or change, suspend, discontinue or modify any
                  aspect of any Website. Such modifications may include, without limitation, changes in content, in user priorities, and discontinuance of
                  functional aspects of any Website. Your continued use of any Website after the posting of revisions to the Terms Of Use shall constitute your
                  acceptance to be bound by the express terms of any such revisions.
                </div>
                <div className={classes.termsSubtitle}>1. CERTIFICATION OF USER</div>
                <div className={classes.termsPara}>
                  By using or attempting to use this Website, you certify to HomeVestors that you are a resident of the United States or otherwise authorized to
                  conduct business in the United States, are at least 18 years of age or older, have the legal capacity to enter into this Agreement and that
                  you are a professional investor in the real estate home buying industry.
                </div>
              </Paper>
              <div className={classes.termsSubtitle}>2. CONTENT AND REGISTRATION</div>
              <div className={classes.termsPara}>
                <span>2.1.</span>{' '}
                <p>
                  The Website content shall mean all areas and aspects of the Website and Services including, without limitation, text, data, photos, graphics
                  and/or video or any information whatsoever obtained through the Website (collectively referred to herein as “Information”), HomeVestors’
                  computers or network and any subscription or software, product, service, or information provided by HomeVestors.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>2.2</span>{' '}
                <p>
                  Vendor Content. HomeVestors has entered into contractual relationships with certain vendors, sponsors, and advertisers of products or services
                  (“Vendors”), pursuant to which HomeVestors may link to or display information, advertisements, discounts, products, goods, or services offered
                  by the Vendors (“Vendor Content”). HomeVestors does not guarantee the availability or accuracy of any such Vendor Content or offers, nor does
                  it endorse, guarantee nor insure any Vendor products or services.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>2.3</span>
                <p>
                  HomeVestors shall not be held liable, directly or indirectly, for any loss or damage caused by your use of: (a) any external site linked to
                  the Service, (b) Vendor Information, or (c) Vendor products or services. Statements made on the Service Area concerning the products or
                  services of HomeVestors do not constitute an offer, but are merely solicitations of an offer.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>2.4</span>
                <p>
                  Registration. You may browse and view certain content on the Website without registering, but as a condition to using certain other aspects of
                  the Website or accessing certain services, you may be required to register and select a user identification and password. You agree to
                  maintain the confidentiality of such registration information, be the sole user of such registration and use your registration solely to
                  access the Website and to obtain Services. HomeVestors reserves the right to monitor your use of the registration and to discontinue you it at
                  any time in HomeVestors sole discretion. If you believe that your registration has been compromised, you must promptly change your
                  registration information and notify us immediately.
                </p>
              </div>

              <div className={classes.termsSubtitle}>3. LIMITATIONS ON USE AND USER SUBMISSIONS.</div>

              <div className={classes.termsPara}>
                <span>3.1.</span>
                <p>
                  Copyright, Patent and Trademark Notice. All content of the Website provided by HomeVestors, including, but not limited to, all text, photos,
                  graphics, audio, software, webpage layouts or configurations, presentations in any format and/or video is copyrighted by HomeVestors of
                  America, Inc., or its affiliates or subsidiaries. Copyright © 2013-2019 HomeVestors of America, Inc. All rights reserved.
                </p>
              </div>

              <div className={classes.termsParaLeft}>
                No portion of the Content or other materials may be directly or indirectly copied, published, reproduced, modified, performed, displayed, sold,
                transmitted, published, broadcast, rewritten for broadcast or publication or redistributed in any medium, whether now known or hereafter
                created. The foregoing prohibition includes, but is not limited to “screen scraping” or “database scraping” to obtain lists of users or other
                Information. Nor may any portion of the Information or other materials be stored in a computer or distributed over any network, except that you
                may download or print one copy of pages strictly for personal and non-commercial use; however, any print out of any page of the Website or
                portion thereof, must include HomeVestors’ copyright notice.
              </div>

              <div className={classes.termsParaLeft}>
                HomeVestors, and its associated logos, page headers, custom graphics, buttons, and other icons are service marks, trademarks, registered service
                marks, registered trademarks, and/or trade dress of HomeVestors. All other content product names and company logos are trademarks of their
                respective owners. Neither these materials, nor any portion thereof, may be stored in a computer except as reasonably necessary for personal and
                non-commercial use; however, any print out of any page of the Website or portion thereof, must include HomeVestors’ copyright notice and/or
                trademark registration notice as appropriate.
              </div>

              <div className={classes.termsPara}>
                <span>3.2.</span>
                <p>
                  {' '}
                  Notice of Copyright Infringement. HomeVestors respects the copyrights of others. HomeVestors reserves the right, but not the obligation, to
                  terminate your license to use the Services if it determines in its sole and absolute discretion that you are involved in infringing activity,
                  including alleged acts of first-time or repeat infringement, regardless of whether the material or activity is ultimately determined to be
                  infringing. HomeVestors has implemented procedures for receiving written notification of claimed infringements. If you believe that your
                  copyrighted work has been reproduced on the Website in a way that constitutes copyright infringement you may notify our designated copyright
                  agent, Charles E. Phipps, Locke Lord LLP, J.P. Morgan Chase Tower, 2200 Ross Avenue, Suite 2800, Dallas, Texas 75201, or by e-mail at
                  cphipps@lockelord.com.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>3.3.</span>
                <p>
                  {' '}
                  Restricted Use of the Site. You agree to use the Service Area and Information for lawful purposes only. You agree not to post or transmit any
                  information through the Service Area which: (a) infringes any patent, trademark or copyright rights of others or violates their privacy or
                  publicity rights, (b) is unlawful, threatening, abusive, defamatory, libelous, vulgar, obscene, profane, indecent or otherwise objectionable,
                  or (c) is protected by patent, copyright, trademark or other proprietary right without the express permission of the owner of such right. You
                  shall be solely liable for any damages resulting from any infringement of patent, copyright, trademark or other proprietary rights, or any
                  other harm resulting from your use of the Service.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>3.4.</span>
                <p>
                  {' '}
                  Your Submission of Messages. You hereby grant to HomeVestors a worldwide, royalty-free, perpetual, irrevocable, non-exclusive right and
                  license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform, display and use for any
                  purpose all messages or other materials posted by you on the Service or any e-mail sent by you to HomeVestors (in whole or in part) and to
                  incorporate any such messages or other materials or e-mails in any form, into other media or technology whether now known or hereafter
                  developed.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>3.5.</span>
                <p>
                  {' '}
                  Public messages. All electronic forums made available to users of the Service are the sole property of HomeVestors and are not a public forum.
                  You understand and acknowledge that all information, data, files, software, music, sound, photographs, graphics, video, messages or other
                  materials posted by any person or entity other than HomeVestors (“Third-Party Content”), whether publicly posted or privately transmitted, are
                  the sole responsibility of the person from which such Third-Party Content originated. You assume total liability for all Third-Party Content
                  that you upload, post, email or otherwise transmit via the Service. HomeVestors assumes no liability for any such Third-Party Content. You
                  agree not to use the Service to:
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>A. </span>
                <p>
                  upload, post, e-mail or otherwise transmit any Third-Party Content that is unlawful, harmful, threatening, abusive, harassing, tortious,
                  defamatory, vulgar, obscene, libelous, invasive of another’s privacy, or hateful, or is racially, ethnically or otherwise objectionable;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>B. </span>
                <p>harm minors in any way;</p>
              </div>

              <div className={classes.termsPara}>
                <span>C. </span>
                <p>
                  falsely represent yourself, your status or your affiliations, including but not limited to, impersonating any person or entity, falsely
                  representing yourself as a professional real estate investor, falsely representing yourself as‎ an official or representative of HomeVestors,
                  or falsely representing your affiliation with any person or entity;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>D. </span>
                <p>forge headers or otherwise manipulate identifiers to disguise the origin of any Content transmitted through the Service;</p>
              </div>

              <div className={classes.termsPara}>
                <span>E. </span>
                <p>
                  upload, post, e-mail or otherwise transmit any Third-Party Content that you do not have a right to transmit under any law or under contractual
                  or fiduciary relationships (such as inside information, proprietary and confidential information learned or disclosed as part of employment
                  relationships or under nondisclosure agreements);
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>F. </span>
                <p>
                  upload, post, e-mail or otherwise transmit any Third-Party Content that infringes any patent, trademark, trade secret, copyright or other
                  proprietary rights of any party;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>G. </span>
                <p>
                  upload, post, e-mail or otherwise transmit any unsolicited or unauthorized advertising, promotional materials, “junk mail,” “spam,” “chain
                  letters,” “pyramid schemes,” or any other form of solicitation;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>H. </span>
                <p>
                  upload, post, e-mail or otherwise transmit any material that contains software viruses or any other computer code, files or programs designed
                  to interrupt, destroy or limit the functionality of any computer software or hardware or telecommunications equipment or network;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>I. </span>
                <p>
                  disrupt the normal flow of dialogue, cause a screen to “scroll” faster than other users of the Service are able to type, or otherwise act in a
                  manner that negatively affects other users’ ability to engage in real time exchanges;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>J. </span>
                <p>
                  interfere with or disrupt the Service or servers or networks connected to the Service, or disobey any requirements, procedures, policies or
                  regulations of networks connected to the Service;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>K. </span>
                <p>
                  intentionally or unintentionally violate any applicable local, state, national or international law, including, but not limited to,
                  regulations promulgated by the U.S. Securities and Exchange Commission, any rules of any national or other securities exchange, including,
                  without limitation, the New York Stock Exchange, the American Stock Exchange or the NASDAQ, and any regulations having the force of law;
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>L. </span>
                <p>“stalk” or otherwise harass another; or</p>
              </div>

              <div className={classes.termsPara}>
                <span>M. </span>
                <p>collect or store personal data about other users.</p>
              </div>

              <div className={classes.termsParaLeft}>
                You acknowledge that HomeVestors does not pre-screen Third-Party Content, but that HomeVestors and its designees shall have the right (but not
                the obligation) in their sole discretion to refuse or move any Third-Party Content that is available via the Service. Without limiting the
                foregoing, HomeVestors and its designees shall have the right to remove any Third-Party Content that violates this Agreement or is otherwise
                objectionable. You agree that you must evaluate, and bear all risks associated with, the use of any Third-Party Content, including any reliance
                on the accuracy, completeness, or usefulness of such Third-Party Content.
              </div>

              <div className={classes.termsParaLeft}>
                You acknowledge and agree that HomeVestors may preserve Third-Party Content and may also disclose Third-Party Content if required to do so by
                law or in the good faith belief that such preservation or disclosure is reasonably necessary to: (a) comply with legal process; (b) enforce this
                Agreement; (c) respond to claims that any Third-Party Content violates the rights of other third-parties; or (d) protect the rights, property,
                or personal safety of HomeVestors, its users, or the public.
              </div>

              <div className={classes.termsPara}>
                <span>3.6.</span>
                <p>
                  {' '}
                  Linking. Without the prior written consent of HomeVestors, you may not use any of HomeVestors’ proprietary logos, marks, or other distinctive
                  graphics, video, or audio material in your links. You may not link to the Website or to any page thereof or engage in the practice of “deep
                  linking” in any manner reasonably likely to: (a) imply affiliation with or endorsement or sponsorship of or by HomeVestors; (b) cause
                  confusion, mistake, or deception; (c) dilute HomeVestors’ trademarks or service marks; (d) otherwise violate state or federal law; or (e)
                  constitute improper disparagement or disclosure concerning HomeVestors or any of its respective affiliates, or their respective officers,
                  directors, agents, franchises, or Vendors. You may not frame or otherwise incorporate into another Website any of the Information or other
                  materials on this Website without the prior written consent of HomeVestors.
                </p>
              </div>

              <div className={classes.termsSubtitle}>4. ACCESS AND DELAYS IN SERVICES.</div>

              <div className={classes.termsPara}>
                HomeVestors, its affiliates, subsidiaries, and Vendors shall have no responsibility to provide you access to the Website. Further, HomeVestors,
                its affiliates, subsidiaries, and Vendors shall not be liable to you for any loss or liability resulting, directly or indirectly, from delays,
                inaccuracies, errors, omissions or interruptions of the Service for any reason, including, without limitation, due to electronic or mechanical
                equipment failures, telephone interconnect problems, defects, weather, strikes, walkouts, fire, acts of God, riots, armed conflicts, acts of
                war, acts of terrorism, or to other like causes.
              </div>

              <div className={classes.termsSubtitle}>5. MONITORING OF SITE.</div>

              <div className={classes.termsPara}>
                You acknowledge that HomeVestors reserves the right to, and may from time to time, monitor for all lawful purposes any and all Third-Party
                Content transmitted or received through the Service. During monitoring, information may be examined, recorded, copied, and used for authorized
                purposes. All Third-Party Content, including personal information, placed on or sent over the Service may be monitored. Use of the Service,
                authorized or unauthorized, constitutes consent to such monitoring and to the other terms of this Agreement.
              </div>

              <div className={classes.termsSubtitle}>6. REPRESENTATIONS, WARRANTIES AND LIMITATION OF LIABILITY.</div>

              <div className={classes.termsPara}>
                <span>6.1.</span>
                <p>
                  {' '}
                  General Disclaimer and Limited Warranty. You acknowledge that certain aspects of the Information and/or Vendor Information and links provided
                  through the Website are compiled from sources which may be beyond the control of HomeVestors. Though such Information and links are recognized
                  by the parties to be generally reliable, the parties acknowledge that inaccuracies may occur. HomeVestors, its licensors and Vendors do not
                  warrant the accuracy or suitability of any such Information. Neither HomeVestors nor its licensors or Vendors represent or endorse the
                  accuracy or reliability of the Information distributed through the Service.
                </p>
              </div>

              <div className={classes.termsParaLeft}>
                FOR THIS REASON, YOU ACKNOWLEDGE THAT THE WEBSITE IS PROVIDED TO YOU ON AN “AS IS WITH ALL FAULTS BASIS.” HOMEVESTORS AND ITS LICENSORS AND
                VENDORS EXPRESSLY DISCLAIM ANY AND ALL WARRANTIES, WHETHER EXPRESS, ORAL, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING ANY IMPLIED WARRANTY OF
                MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, OR ANY WARRANTIES ARISING BY VIRTUE OF CUSTOM OF TRADE OR COURSE OF
                DEALING. FURTHER, HOMEVESTORS AND ITS LICENSORS AND VENDORS NEITHER REPRESENT NOR WARRANT THAT THE WEBSITE WILL MEET YOUR REQUIREMENTS OR IS
                SUITABLE FOR YOUR NEEDS OR WILL ACHIEVE ANY DESIRED RESULT.
              </div>

              <div className={classes.termsPara}>
                <span>6.2. </span>
                <p>
                  You assume all risk of errors and/or omissions in the Website, including the transmission or translation of data. You assume full
                  responsibility for implementing sufficient procedures and checks to satisfy your requirements for the accuracy and suitability of the Website,
                  including the Information, and for maintaining any means which you may require for the reconstruction of lost data or subsequent manipulations
                  or analyses of the Information provided under this Agreement.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>6.3. </span>
                <p>
                  {' '}
                  Viruses. YOU ACKNOWLEDGE AND AGREE THAT HOMEVESTORS USES REASONABLE EFFORTS TO ASSURE THAT NO VIRUSES OR PROGRAMS WITH SIMILAR FUNCTIONS
                  OPERATE ON, OR ARE PASSED THROUGH, THE WEBSITE OR THE INFORMATION. HOWEVER, YOU HEREBY ASSUME ALL RESPONSIBILITY (AND THEREBY HOLD HOMEVESTORS
                  HARMLESS), BY WHATEVER MEANS YOU DEEM MOST APPROPRIATE FOR YOUR NEEDS, FOR DETECTING AND ERADICATING ANY VIRUS OR PROGRAM WITH A SIMILAR
                  FUNCTION.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>6.4.</span>
                <p>
                  {' '}
                  LIMITATION OF LIABILITY. YOU AGREE THAT HOMEVESTORS AND ITS AFFILIATES, SUBSIDIARIES, AND VENDORS SHALL NOT IN ANY EVENT BE LIABLE FOR ANY
                  SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE SERVICE FOR ANY PURPOSE WHATSOEVER. IF THE ABOVE
                  LIMITATIONS OF LIABILITIES SHOULD FAIL IN THEIR ESSENTIAL PURPOSE FOR ANY REASON, SUCH LIABILITY IS AND SHALL BE LIMITED TO A SUM EQUAL IN
                  AMOUNT TO TEN (10%) PERCENT OF THE SUMS PAID TO HOMEVESTORS BY YOU UNDER THE TERMS OF THIS AGREEMENT OR $100.00, WHICHEVER IS GREATER, AS
                  LIQUIDATED DAMAGES AND NOT AS A PENALTY EVEN IF HOMEVESTORS OR ITS AFFILIATES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. THIS
                  LIABILITY, IF ANY, SHALL BE COMPLETE AND EXCLUSIVE. THE PROVISIONS CONTAINED IN THIS SECTION 6 SHALL SURVIVE TERMINATION OF THIS AGREEMENT.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>6.5.</span>
                <p>
                  {' '}
                  FTC NOTICE. SOME STATES DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, SO THE ABOVE LIMITATION MAY NOT APPLY TO YOU. SOME
                  STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO
                  YOU. THIS WARRANTY GIVES YOU SPECIFIC LEGAL RIGHTS, AND YOU MAY ALSO HAVE OTHER RIGHTS WHICH VARY FROM STATE TO STATE.
                </p>
              </div>

              <div className={classes.termsSubtitle}>7. INDEMNIFICATION.</div>

              <div className={classes.termsPara}>
                YOU SHALL RELEASE, DISCHARGE, AND RELINQUISH, DEFEND INDEMNIFY AND HOLD HARMLESS HOMEVESTORS AND ITS AFFILIATES, SUBSIDIARIES, AND VENDORS, AND
                EACH OF THEIR MEMBERS, SHAREHOLDERS, DIRECTORS, EMPLOYEES, AGENTS, REPRESENTATIVES, VENDORS, AND CONTRACTORS OF WHATEVER TIER (COLLECTIVELY, THE
                INDEMNITEES) FROM AND AGAINST ALL LOSS, CLAIMS, DEMANDS AND CAUSES OF ACTION OF WHATEVER KIND OR CHARACTER, INCLUDING WITHOUT LIMITATION COSTS,
                ATTORNEYS’ FEES AND EXPENSES INCURRED IN CONNECTION WITH ANY CLAIM BROUGHT BY ANY PERSON(S) OR ENTITY(IES) ARISING FROM, IN CONNECTION WITH, OR
                RELATING TO, YOUR ACCESS AND USE OF THE WEBSITE, INCLUDING YOUR USE OF THE INFORMATION OBTAINED THROUGH THE WEBSITE. THE OBLIGATIONS TO RELEASE,
                DEFEND AND TO INDEMNIFY CONTAINED IN THIS SECTION SHALL APPLY EVEN IF CAUSED, IN WHOLE OR IN PART, BY THE JOINT, SOLE, GROSS OR CONCURRENT
                NEGLIGENCE, STRICT LIABILITY, CONTRACTUAL LIABILITIES OF THIRD PARTIES, OR OTHER FAULT, WHETHER PASSIVE OR ACTIVE, OF ANY PERSON OR ENTITY,
                INCLUDING BUT NOT LIMITED TO THE INDEMNITEES, JOINTLY OR SEVERALLY. YOU SHALL COOPERATE AS FULLY AS REASONABLY REQUIRED IN THE DEFENSE OF ANY
                SUCH CLAIM.
              </div>

              <div className={classes.termsSubtitle}>8. PRIVACY POLICIES</div>

              <div className={classes.termsPara}>
                These Terms of Use include our Privacy Policy as contained on our website, which is incorporated fully herein.
              </div>

              <div className={classes.termsSubtitle}>9. UNSOLICITED MARKETING.</div>

              <div className={classes.termsPara}>
                <span>9.1.</span>
                <p>
                  {' '}
                  Unsolicited Marketing. HomeVestors supports responsible e-commerce. HomeVestors does not authorize anyone to use the Service to broadcast,
                  distribute, transmit or retransmit unsolicited commercial, non-commercial, bulk, or junk electronic mail, including email (“SPAM”).
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>9.2. </span>
                <p> Electronic Direct Marketing Programs.</p>
              </div>

              <div className={classes.termsParaLeft}>
                HomeVestors may develop and participate in electronic direct marketing to users of the Website who elect to receive electronic mail of specific
                interest to them. In keeping with this Agreement, HomeVestors does not forward the names and addresses (electronic or otherwise) to third
                parties. Advertisers who participate in HomeVestors’ electronic direct marketing programs identify the category of users who would most likely
                be interested in their goods and services. HomeVestors then forwards the advertisements to users who have elected to receive that category of
                electronic mail. Users may elect to not receive similar electronic mail by requesting that their e-mail address be removed from the mailing list
                by selecting the appropriate option included with each e-mail advertisement sent by HomeVestors. In addition, users may elect to be removed from
                such lists at any time by sending a message to the System administrator at webmaster@homevestors.com.
              </div>

              <div className={classes.termsPara}>
                <span>9.3. </span>
                <p>
                  {' '}
                  Reporting SPAM. Users who receive SPAM or any threatening or offensive e-mail through the Services may report it to HomeVestors by forwarding
                  the unedited message with the full message header to webmaster@homevestors.com.
                </p>
              </div>

              <div className={classes.termsPara}>
                <span>9.4. </span>
                <p>
                  {' '}
                  Reservation of Rights. HomeVestors reserves the right to take all legal or technical steps that it deems necessary to prevent the broadcast,
                  distribution, transmission, or retransmission over the Service of SPAM, junk e-mail, threatening or offensive e-mail, or e-mail otherwise
                  determined by HomeVestors, in its sole discretion, to be objectionable. HomeVestors reserves the right to suspend or terminate any person or
                  entity’s use of or access to the Service if it determines, in its sole and absolute discretion, that such person has used or intends to use
                  the Service in violation of this policy. A failure of HomeVestors to exercise any right provided for herein shall not be deemed to be a waiver
                  of such right.
                </p>
              </div>
              <div className={classes.termsSubtitle}>10. MISCELLANEOUS</div>
              <div className={classes.termsPara}>
                <span>10.1. </span>
                <p> Governing Law; Limitations; Venue.</p>
              </div>
              <div className={classes.termsParaLeft}>
                The laws of the State of Texas, excluding any rule or principle that would refer to and apply the substantive law of another state or
                jurisdiction, shall govern this Agreement. To the extent allowed by applicable law, any claims or causes of action arising from or relating to
                your access and use of the Service as contemplated by this Agreement must be instituted within two (2) years from the date upon which such claim
                or cause arose. Further, any such claim or cause of action shall be brought EXCLUSIVELY in the state or federal courts located in Dallas County,
                Texas, and you agree to submit to the exclusive personal jurisdiction of such courts and hereby appoint the Secretary of State of Texas as your
                agent for service of process. You agree to waive any objection that the state or federal courts of Dallas County, Texas, are an inconvenient
                forum.
              </div>
              <div className={classes.termsPara}>
                <span>10.2. </span>
                <p>
                  {' '}
                  Assignments. You may not assign any of your rights, obligations, privileges, or performance hereunder without the prior written consent of
                  HomeVestors. Any assignment other than as provided for in this Section 10.2 shall be null and void.
                </p>
              </div>
              <div className={classes.termsPara}>
                <span>10.3. </span>
                <p>
                  {' '}
                  Severability. If any provision of this Agreement is found to be unlawful or unenforceable in any respect, the court shall reform such
                  provision so as to render it enforceable (or, if it is not possible to reform such provision so as to make it enforceable, then delete such
                  provision); and, as so reformed or modified, fully enforce this Agreement.
                </p>
              </div>
              <div className={classes.termsPara}>
                <span>10.4 </span>
                <p>
                  {' '}
                  Connectivity Charges. You understand that your access to the Website and use of the Services may incur third party connectivity charges. You
                  understand that you are responsibly for any such charges that your use incurs, including from your cell phone or internet service provider,
                  including fees related to text messaging and data fees.
                </p>
              </div>
              <div className={classes.termsPara}>
                <span>10.5. </span>
                <p>
                  {' '}
                  Termination. HomeVestors may terminate or suspend your use of the Website for any reason. Termination or cancellation of your use of the
                  Website shall not affect any right or relief to which HomeVestors may be entitled, at law or in equity. Upon termination of this Agreement,
                  all rights granted to you will terminate and revert to HomeVestors.
                </p>
              </div>
              <div className={classes.termsPara}>
                <span>10.6. </span>
                <p>
                  {' '}
                  Notice. Official correspondence must be sent via postal mail to: HomeVestors of America, Inc. 6500 Greenville Avenue, Suite 400 Dallas, TX
                  75206.
                </p>
              </div>
              <div className={classes.termsPara}>
                <span>10.7</span>
                <p> Notice Regarding Electronic Commercial Service for California Users.</p>
              </div>
              <div className={classes.termsParaLeft}>
                Pursuant to California Civil Code Section 1789.3, California Site users are entitled to the following specific consumer rights notice: The
                Complaint Assistance Unit of the Division of consumer Services of the California Department of consumer Affairs may be contacted in writing at
                1625 North Market Blvd., Sacramento, CA 95834, or by telephone at (916) 445-1254 or (800) 952-5210.
              </div>
              <div className={classes.termsPara}>
                <span>10.8 </span>
                <p>
                  {' '}
                  Entire Agreement. This Agreement is complete and effective at the time you begin use of the Service. This Agreement constitutes the entire
                  agreement between the parties, and no other agreement, written or oral, exists between you and HOMEVESTORS. In the event that any
                  inconsistencies exist between this Agreement and any future published terms or understanding, the last published Agreement or terms of use
                  shall control.
                </p>
              </div>
              <div className={classes.termsboldPara}>ANY RIGHTS NOT EXPRESSLY GRANTED HEREIN ARE RESERVED BY HOMEVESTORS OF AMERICA, INC.</div>
              <div className={classes.termsPara}>© 2019 HomeVestors of America, Inc. All rights reserved.</div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    )
  }
}

export default withStyles(styles)(Terms)



// WEBPACK FOOTER //
// ./src/containers/Terms.js